import axios from 'axios'

const baseURL = process.env.VUE_APP_ADMIN_SERVER + '/api/roles'

export default {
  namespaced: true,
  state: {
    is_loading: null,
    is_processing: null,
    roles: [],
    permissions: { }
  },
  mutations: {
    setRoles (state, payload) {
      state.roles = payload
    },
    setPermissions (state, payload) {
      state.permissions = payload
    },
    removeRoleItem (state, id) {
      const index = state.roles.findIndex(item => item.id === id)

      if (index !== -1) {
        state.roles.splice(index, 1)
      }
    }
  },
  actions: {
    async getRoles ({ commit, state }) {
      state.is_loading = true
      const promise = axios.get(baseURL)

      promise.then(response => {
        commit('setRoles', response.data.data)
        state.is_loading = false
      })
    },
    async getRole ({ commit, state }, id) {
      state.is_loading = true
      const promise = axios.get(baseURL + '/' + id)

      promise.then(response => {
        state.is_loading = false
      })

      return promise
    },
    async createRole ({ commit, state }, data) {
      state.is_processing = true
      const promise = axios.post(baseURL, data)

      promise.then(() => {
        state.is_processing = false
      }).catch(() => {
        state.is_processing = false
      })

      return promise
    },
    async updateRole ({ commit, state }, data) {
      state.is_processing = true
      const promise = axios.put(baseURL + '/' + data.id, data)

      promise.then(() => {
        state.is_processing = false
      }).catch(() => {
        state.is_processing = false
      })

      return promise
    },
    async deleteRole ({ commit, state }, id) {
      state.is_processing = true
      const promise = axios.delete(baseURL + '/' + id)

      promise.then(() => {
        state.is_processing = false
        commit('removeRoleItem', id)
      }).catch(() => {
        state.is_processing = false
      })

      return promise
    },
    async getAllPermissions ({ commit, state }) {
      const promise = axios.get(baseURL + '/permissions')
      promise.then(response => {
        commit('setPermissions', response.data)
      })
    }
  }
}
